export default __webpack_public_path__ + "static/media/chevron-blue.517d19f7.svg";